import { Button, Dialog, DialogContent, DialogHeader, DialogTitle, Text } from '@flatfile/baseline'
import { useEffect, useState } from 'react'
import Cal, { getCalApi } from '@calcom/embed-react'
import { useIdentity } from '../../hooks/useIdentity'
import { logger } from '../../utils/logging'

import projectsDemo from '/images/projects-demo.jpg'

export const DemoPage = () => {
  const { identity } = useIdentity()
  const [calendarModalOpened, setCalendarModalOpened] = useState(false)

  useEffect(() => {
    const initializeCalendar = async () => {
      try {
        const cal = await getCalApi({ namespace: 'demo-dash' })

        if (!cal) {
          throw new Error('Failed to initialize calendar API')
        }

        cal('ui', {
          styles: {
            branding: {
              brandColor: '#000000',
            },
          },
          hideEventTypeDetails: false,
          layout: 'month_view',
        })
      } catch (error) {
        logger.error('Calendar initialization failed:', error)
      }
    }

    initializeCalendar()
  }, [])

  return (
    <div
      className='flex justify-center items-center'
      style={
        calendarModalOpened
          ? {
              filter: 'blur(5px)',
              transition: 'filter 0.25s ease',
            }
          : {}
      }
    >
      <div className='px-6 py-6 max-w-[800px]'>
        <Text variant='title1' emphasized>
          Flatfile Projects
        </Text>
        <div className='h-6' />
        <Text variant='body'>
          Our self-service product experience is designed for frontend developers who need an embeddable data import
          tool.
        </Text>
        <div className='h-4' />
        <Text variant='body'>
          <Text variant='body' emphasized as='span'>
            Flatfile Projects
          </Text>{' '}
          is our solution for teams responsible for onboarding or migrating customer data. This isn't just another tool
          in your tech stack. By combining human guidance with machine intelligence, we're making data onboarding and
          migration faster, more accurate, and more collaborative than ever before.
        </Text>
        <div className='h-4' />
        <div className='flex justify-center w-full'>
          <img src={projectsDemo} alt='Flatfile Projects interface' className='w-[600px]' />
        </div>
        <div className='h-6' />
        <Text variant='body' emphasized>
          Projects doesn't just move data. It empowers your team to:
        </Text>
        <ul className='list-disc pl-6 mt-2'>
          <li className='mb-1 text-sm'>Transform complex data scenarios with intelligent mapping rules</li>
          <li className='mb-1 text-sm'>Collaborate in real-time with both technical and non-technical stakeholders</li>
          <li className='mb-1 text-sm'>Maintain data accuracy at enterprise scale</li>
          <li className='mb-1 text-sm'>Adapt to any data structure with flexible mapping capabilities</li>
          <li className='mb-1 text-sm'>Keep sensitive information secure with role-based access</li>
        </ul>
        <Text variant='body' className='mt-4'>
          Interested in seeing Projects in action? In just 30 minutes of your time, we can walk you through how Flatfile
          helps 3000+ teams like yours solve their data headaches.
        </Text>
        <div className='h-4' />
        <Button variant='primary' size='md' onClick={() => setCalendarModalOpened(true)}>
          Book A Demo
        </Button>

        <Dialog open={calendarModalOpened} onOpenChange={(open) => setCalendarModalOpened(open)}>
          <DialogContent className='max-w-2xl'>
            <DialogHeader>
              <DialogTitle>Book A Demo</DialogTitle>
            </DialogHeader>
            <div className='flex justify-center'>
              <Cal
                namespace='demo-dash'
                calLink='team/flatfile/demo-dash'
                style={{ width: '100%', height: '100%', overflow: 'scroll' }}
                config={{ layout: 'month_view', name: identity.user.name, email: identity.user.email }}
              />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  )
}
